export default "__VITE_ASSET__e29cff79__"